/**
 * @file configurations.types.ts
 * @module app/modules/setting/types/configurations.types
 * @description Shared types and constants for the Configurations tab.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.3.5
 * @version 2.1.2
 */

/**
 * Interface describing a configuration record used in the settings tab.
 * Includes display, value, type, control, group, and option metadata for dynamic rendering.
 */
export interface IFlagItem {
  key: string;
  title: string;
  description?: string;
  type: 'bool' | 'int' | 'text' | 'action';
  control?: 'switch' | 'dropdown' | 'text' | 'textarea' | 'number' | 'multi-select' | 'button' | 'hidden';
  options?: Array<string | { label: string; value: string }>;
  value: any;
  defaultValue: any;
  group?: string;
  subgroup?: string;
  subgroupCaption?: string;
  isDisabled?: boolean;
  hide?: boolean;
  isGlobal?: boolean;
  defaultFormat?: string;
}

export const GROUP_ORDER = ['general', 'user', 'catalog', 'ats_draft_po', 'finance', 'sales', 'order', 'notification', 'developer'];

/** Section titles that cannot be built from the key. */
export const GROUP_TITLES: Record<string, string> = { ats_draft_po: 'Replenishment & Draft PO' };
